import { columnTextField } from "utils/tables-utils";
import {
  Button,
  Card,
  CardContent,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import TableComponent from "components/_refactor/table/table";

import { Create, Delete, Add, Visibility } from "@mui/icons-material";

export default function TableManuaisEProcedimentos({
  dataTable,
  search,
  sizePerPage,
  page,
  totalRegistros,
  toggleFormDialog,
  searching,
  selectedDocument,
}) {
  const columnModel = [
    columnTextField({
      dataField: "Titulo",
      text: "Título",
      sort: false,
    }),
    columnTextField({
      dataField: "DataInclusaoFormat",
      text: "Data Inclusão",
      sort: false,
    }),
    columnTextField({
      dataField: "Tipo",
      text: "Tipo",
      sort: false,
    }),
    columnTextField({
      dataField: "Descricao",
      text: "Descrição",
      sort: false,
    }),
    columnTextField({
      dataField: "editar",
      text: "",
      formatter: (_, row) => {
        return searching ? null : (
          <Tooltip title="Editar">
            <IconButton
              size="small"
              onClick={() => {
                selectedDocument(row);
                toggleFormDialog("edit");
              }}
            >
              <Create size="small" />
            </IconButton>
          </Tooltip>
        );
      },
    }),
    columnTextField({
      dataField: "visualizar",
      text: "",
      formatter: (_, row) =>
        searching ? null : (
          <Tooltip title="Visualizar">
            <IconButton
              size="small"
              onClick={() => {
                selectedDocument(row);
                toggleFormDialog("view");
              }}
            >
              <Visibility size="small" />
            </IconButton>
          </Tooltip>
        ),
    }),
    columnTextField({
      dataField: "remover",
      text: "",
      formatter: (_, row) =>
        searching ? null : (
          <Tooltip title="Excluir">
            <IconButton
              size="small"
              onClick={() => {
                selectedDocument(row);
                toggleFormDialog("remove");
              }}
            >
              <Delete size="small" />
            </IconButton>
          </Tooltip>
        ),
    }),
  ];

  return (
    <Card>
      <CardContent>
        <TableComponent
          searched={Boolean(dataTable)}
          keyField="IdDocumentoArea"
          dataTable={dataTable}
          columnModel={columnModel}
          headerTitle="Lista de Manuais"
          loading={searching}
          reshearch={() =>
            search(null, { page: page + 1, sizePerPage: sizePerPage })
          }
          pagination={{
            options: [25, 50, 100],
            totalSize: totalRegistros,
            page: page + 1,
            sizePerPage: sizePerPage,
            showTotal: true,
          }}
          allowEmpty
          noResultTitle="Sua pesquisa não localizou categorias cadastradas."
          bootstrapTableProps={{
            remote: true,
            onTableChange: search,
          }}
          noResultSubtitle="Verifique os filtros utilizados e tente novamente."
          extraActions={
            <Button
              variant="contained"
              onClick={() => toggleFormDialog("create")}
              disabled={searching}
            >
              <Add /> Inserir
            </Button>
          }
        />
      </CardContent>
    </Card>
  );
}
